import React, { useMemo } from 'react';
import CommonFilter from '../components/CommonFilter';
import RealtimeSteamReviews from './RealtimeSteamReviews';
import CardCommon from '@op/components/CardCommon';
import RealtimeFilteredReviews from './RealtimeFilteredReviews';
import useGetStoreTimeline from '@op/pages/gamestore/hooks/useGetPcConsoleTimeline';
import steamPerformancePoint from '@op/operationLog/pages/steamPerformanceRealtimeRatings';
import SteamFeedsReviewsDetailed from '../components/SteamFeedsReviewsDetailed';
import SteamSupportLanguage from '../SteamRatings/SteamSupportLanguage';
import { connect } from 'umi';
import SteamReviews from '@op/widgets/GameStorePlate/widgets/SteamReviews';
const defaultChannel: any = ['steam'];

function RealtimeRatings({
  filter,
  wholeGameInfo,
  gameInfo,
}: {
  filter: any;
  wholeGameInfo: any;
  gameInfo: any;
}) {
  const keepParams = useMemo(() => {
    return {
      ...filter,
      need_link: true,
    };
  }, [filter]);

  const {
    userScoreTrendsLoading,
    userScoreTrendsApiError,
    globalTrendsTimeline,
  } = useGetStoreTimeline({
    keepParams,
    channel: defaultChannel,
  });

  return (
    <>
      <SteamReviews gameInfo={gameInfo} filter={filter}></SteamReviews>

      <RealtimeSteamReviews
        {...globalTrendsTimeline.steam}
        loading={userScoreTrendsLoading}
        filter={filter}
        error={userScoreTrendsApiError}
        wholeGameInfo={wholeGameInfo}
      ></RealtimeSteamReviews>
      <SteamSupportLanguage filter={filter} gameInfo={gameInfo} />
      <CardCommon>
        <RealtimeFilteredReviews
          {...globalTrendsTimeline.steam}
          loading={userScoreTrendsLoading}
          filter={filter}
          error={userScoreTrendsApiError}
          releaseTime={wholeGameInfo.release_time}
        ></RealtimeFilteredReviews>

        {/* <RealtimeNewlyAdded
          {...globalTrendsTimeline.steam}
          filter={filter}
          loading={userScoreTrendsLoading}
        ></RealtimeNewlyAdded> */}
      </CardCommon>
      <SteamFeedsReviewsDetailed
        filter={filter}
        isStacked
        isRealtime
        statsDetailType="steam-performance-keyword-ratings"
        statsLanguageDetailType="steam-ratings-language"
      ></SteamFeedsReviewsDetailed>
    </>
  );
}

function RealtimeRatingsPage({ gameInfo }: { gameInfo: any }) {
  return (
    <CommonFilter
      steamPerformancePoint={steamPerformancePoint}
      title={'Realtime Ratings'}
      hasOnlyHours
    >
      {({ filter, wholeGameInfo }) => {
        return (
          <>
            <RealtimeRatings
              wholeGameInfo={wholeGameInfo}
              filter={filter}
              gameInfo={gameInfo}
            ></RealtimeRatings>
          </>
        );
      }}
    </CommonFilter>
  );
}

export default connect((state: { opinionCommon: any }) => {
  const { opinionCommon } = state;

  return {
    gameInfo: opinionCommon.gameInfo,
  };
})(RealtimeRatingsPage);
